import { render, staticRenderFns } from "./RemoveConfirmationModal.vue?vue&type=template&id=40d48ea9&scoped=true&"
import script from "./RemoveConfirmationModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RemoveConfirmationModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RemoveConfirmationModal.vue?vue&type=style&index=0&id=40d48ea9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d48ea9",
  null
  
)

export default component.exports